export default function WhatsAppButton() {
  return (
    <a
      href="https://wa.me/27681593340" // WhatsApp link with your number
      target="_blank"
      rel="noopener noreferrer"
      className="whatsapp-button"
    >
      💬
    </a>
  );
}
